module.exports = __webpack_public_path__ + "static/media/innovator-feature-third.8774a36b.jpg";